import BlotterLogo from 'components/BlotterLogo'
import Button from 'components/Button'
import ContentScheduleDiagram from 'components/ContentScheduleDiagram'
import Footer from 'components/Footer'
import LeadForm from 'components/LeadForm'
import Link from 'components/Link'
import StripeCheckoutButton from 'components/StripeCheckoutButton'
import getConfig from 'next/config'
// import { createSharingLead, CreateSharingLead } from 'data/sharing/lead/client'
// import TwitterLogin from 'components/TwitterLogin'
import styles from './StartSharingView.module.css'

const StartSharingView = () => {
  const { publicRuntimeConfig } = getConfig()
  return <div className={styles.startSharingView}>
    <a href='/' className='absolute top-5 left-1 sm:top-2 sm:left-1 ml-2'>
      <BlotterLogo size='small' />
    </a>

    <main className='min-h-screen font-[Habibi]'>
      <div className='w-full'>
        <div className='mt-32 text-left mx-auto max-w-[98vw] md:max-w-2xl'>
          <h1 className='text-[7vw] text-navy-500 sm:text-3xl md:text-[2.2rem] tracking-tight !leading-tight px-4 md:px-0'>
            Start using Blotter now and get your Tweet and Thread Preview for FREE
          </h1>
          <ContentScheduleDiagram />
          <h3 className='mt-6 mb-8 text-[5vw] sm:text-3xl md:text-[1.3rem] text-slate-600 tracking-tight !leading-tight px-4 md:px-0'>
            Blotter converts your blog posts into <Link className='!text-slate-600' href='#what-is-tweet-and-thread-content-schedule'>a Tweet and Thread Content Schedule</Link>, automatically.</h3>
          <h3 className='text-[5vw] mt-6 mb-8 sm:text-3xl md:text-[1.3rem] text-slate-600 tracking-tight !leading-tight px-4 md:px-0'>For $9, you get 9 Twitter Threads and Tweets planned out for you. That’s enough to supplement your own Tweets for about a week — check out our example content schedule, above.
          </h3>
          <div className='flex gap-4 items-center flex-wrap md:flex-nowrap px-4 md:px-0 justify-center md:justify-start'>
            <StripeCheckoutButton
              tierId={publicRuntimeConfig.sharingTierId}
              className='!bg-rose-500 !hover:bg-rose-600'
            >
              <>Get my Tweets and Threads for just $9 &raquo;</>
            </StripeCheckoutButton>
            <div className='text-slate-600 text-center md:text-left w-full'>or, sign up for a free preview below</div>
          </div>
          <h3 className='mt-6 mb-8 text-[5vw] sm:text-3xl md:text-[1.3rem] text-slate-600 tracking-tight !leading-tight px-4 md:px-0'>The generated Tweet content is yours to do with as you please — you can edit it, Tweet as is, or use it to spark your own writing.</h3>
          <h2 className='font-[Montserrat] font-bold mt-36 mb-8 text-[5vw] sm:text-3xl md:text-[1rem] text-bold text-slate-600 !leading-tight px-4 md:px-0'>Your free preview</h2>
          <h3 className='mt-6 mb-8 text-[5vw] sm:text-3xl md:text-[1.3rem] text-slate-600 tracking-tight !leading-tight px-4 md:px-0'>Your free preview will be a subset of the Content Schedule, including 2-4 Tweets and/or Threads.</h3>
          <h3 className='mt-6 mb-8 text-[5vw] sm:text-3xl md:text-[1.3rem] text-slate-600 tracking-tight !leading-tight px-4 md:px-0'>Just enter your email address and blog URL, and we’ll start the process.</h3>
          {/* <div className='w-full flex justify-center'>
            <div className='w-80 mb-12'>
              <TwitterLogin />
            </div>
          </div> */}
          <div className='mb-24'>
            <LeadForm
              submitButtonText='Send my FREE Twitter Threads Preview &raquo;'
            />
          </div>
          <div className='p-4 w-full bg-slate-100 mb-12 sm:rounded-lg text-slate-800 text-left text-base'>
            <h3 className='font-bold text-lg' id='what-is-tweet-and-thread-content-schedule'>What is a Tweet and Thread Content Schedule?</h3>
            <p className='mb-2'>Blotter analyzes your blog posts and turns them into Tweets and Twitter Threads. You receive a "Tweet and Thread Content Schedule" — your personalized Tweet and Twitter Thread content laid out with recommended publish dates.</p>
            <p className='mb-2'>Depending on the style and length of your blog posts, the number of Tweets/Threads (and proportion of each) generated varies widely.</p>
            <p className='mb-2'>If Blotter isn’t able to convert your blog post content into at least 9 Tweets/Threads, we’ll let you know and discuss options.</p>

            <h3 className='font-bold mt-8 text-lg'>How long does the conversion process take?</h3>
            <p className='mb-2'>Blotter’s conversion process includes both algorithms and human beings, so the process is not instantaneous. Having humans involved ensures that your content won’t just be AI-generated gibberish. We’ll email you as soon as your Content Schedule is ready!</p>

            <h3 className='font-bold mt-8 text-lg'>Why do you need my email address?</h3>
            <p className='mb-2'>Because Blotter’s conversion process involves humans, it takes time (see details above). We use your email address to notify you when your Content Schedule is ready.</p>

            <h3 className='font-bold mt-8 text-lg'>Who owns the copyright for the content?</h3>
            <p className='mb-2'>You do! The content is based on your blog posts, you’re using Blotter to convert it into Twitter-sized snacks.</p>

            <h3 className='font-bold mt-8 text-lg'>Does the paid version come with a guarantee?</h3>
            <p className='mb-2'>Absolutely. If you aren’t <strong>completely satisfied</strong> with your Tweet and Thread Content Schedule, just <strong>contact us for a full refund, no questions asked.</strong></p>
          </div>
        </div>
      </div>
    </main>

    <footer className='bg-gray-50' aria-labelledby='footer-heading'>
      <h2 id='footer-heading' className='sr-only'>
        Footer
      </h2>
      <div className='max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8'>
        <div className='flex justify-center'>
          <Footer />
          <div className='mb-12 xl:mt-0' />
        </div>
      </div>
    </footer>
  </div>
}

export default StartSharingView
